if (!customElements.get('visual-quantity-selects')) {
  customElements.define('visual-quantity-selects',
    class VisualQuantitySelects extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          this.updateSelectionMetadata(event);
        });
      }

      updateSelectionMetadata({ target }) {
        if (this.closest('[data-swiper-general]')) {
          if (target.dataset.mediaSrc) {
            this.swiperSlider = this.closest('[data-swiper-general]').dataset.swiperGeneral;
            this.gallery = this.closest('[data-swiper-general]').querySelector('.product__slider-main').querySelectorAll('.product__media');

            this.gallery.forEach((media, index) => {
              if (media.dataset.srcAttached === target.dataset.mediaSrc) {
                window.sectionSwipers[this.swiperSlider].slideTo(index);
              }
            });
          }
        }

        if (target.nextElementSibling.querySelector('price-snippet div')) {
          this.newPrice = target.nextElementSibling.querySelector('price-snippet div').innerHTML;
          this.productInfoPrice = this.closest('.product__info-wrapper')?.querySelector('[data-current-price] .price__container div');
          if (this.productInfoPrice) this.productInfoPrice.innerHTML = this.newPrice;

          this.buttonPrice = this.closest('.product__info-wrapper')?.querySelector('[id*="ProductSubmitButton-"] [data-button-price]');
          if (this.newPrice && this.buttonPrice) {
            this.buttonPrice.innerHTML = this.newPrice;
          }
        }

        if (target.dataset.savePercent) {
          document.querySelectorAll('[data-dynamic-save-percent]').forEach(el => {
            el.innerHTML = target.dataset.savePercent;
            el.dataset.dynamicSavePercent = target.dataset.savePercent;
          });
        }

        if (target.dataset.optionDescription) {
          this.querySelector('[data-selected-option-text]').textContent = target.dataset.optionDescription;
        }

        this.stickyATC = document.querySelector('.product__sticky-atc');
        if (this.stickyATC) {
          this.stickyImg = this.stickyATC.querySelector('img');
          this.stickyATC.querySelector('[data-sticky-variant]').innerHTML = target.nextElementSibling.querySelector('[data-quantity-option]').innerHTML;

          if (this.closest('[data-swiper-general]') && target.dataset.mediaSrc) {
            this.stickyCurrentSrc = this.stickyImg.src;
            this.stickyNewSrc = this.stickyCurrentSrc.replace(/(files|products)\/.*/, `${target.dataset.mediaSrc}` + '?width=130');
            this.stickyImg.src = this.stickyNewSrc;
            this.stickyImg.srcset = this.stickyNewSrc + ' 130w';
          }
          
          this.currentPrice = document.querySelector('.product__sticky-atc-info').querySelector('price-snippet');
          this.newPrice = this.closest('.product__info-container').querySelector('price-snippet').innerHTML;
          if(this.newPrice && this.currentPrice) {
            this.currentPrice.innerHTML = this.newPrice;
          }

          this.atcButtonPrice = this.stickyATC.querySelector('[data-atc-button-price] price-snippet');
          if(this.newPrice && this.atcButtonPrice) this.atcButtonPrice.innerHTML = this.newPrice;
        }
      }
    }
  );
}